// extracted by mini-css-extract-plugin
export var csatScore = "_l4-5";
export var header = "_l4-1";
export var panelWrapper = "_l4-2";
export var postPreview = "_l4-3";
export var rightContent = "_l4-0";
export var wrappingText = "_l4-4";